import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoardComponent } from './board/board.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { BoardItemComponent } from './board-item/board-item.component';
import { CommentItemComponent } from './comment-item/comment-item.component';

import { HeaderModule } from '../header/header.module';
import { HeaderComponent } from '../header/header/header.component';
import { DragulaModule } from 'ng2-dragula';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SeeKanbanComponent } from '../see-kanban/see-kanban.component';
import { SeeKanbanRoutingModule } from './seekanban-routing.module';
import { KanbanMenuActionsComponent } from './kanban-menu-actions/kanban-menu-actions.component';
import { MatMenuModule } from '@angular/material/menu';
import { KanbanDialogModule } from '../components/dialog/dialog.module';
import { SeePermissionsKanbanComponent } from '../components/dialog/dialog-permissions-kanban/see-permissions/see-permissions-kanban.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GButtonComponent } from '../../shared/components/g-button/g-button.component';
import { SeeAffectationKanbanComponent } from '../components/dialog/see-affectation/see-affectation-kanban.component';
@NgModule({
  declarations: [
    BoardComponent,
    BoardItemComponent,
    CommentItemComponent,
    SeeKanbanComponent,
    KanbanMenuActionsComponent,
    SeeAffectationKanbanComponent,

  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    DragDropModule,
    MatExpansionModule,
    FormsModule,
    SeeKanbanRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    DragulaModule,
    KanbanDialogModule,
    HeaderModule,
    MatToolbarModule,

  ], 
  exports: [
    BoardComponent,
    SeeAffectationKanbanComponent,

  ]
})
export class BoardModule { }
